import React from 'react';
import { CountryDropdown } from 'react-country-region-selector';

const CountryField = ({ label, value, error, name, handleChange }) => {
	return (
		<div className="input-container" style={{ width: 'calc(50% - 6px)', marginRight: '12px' }}>
			<div className={`input ${error && 'input--error'}`}>
				{label && <span className="styledLabel styledLabel--active">{label}</span>}
				<div className="input--customSelect">
					<CountryDropdown
						valueType="short"
						labelType="full"
						value={value}
						classes="input--select overflowed-select"
						autoComplete="country-name"
						name={name}
						onChange={(value) => {
							handleChange(value);
						}}
					/>
				</div>
			</div>
			{error && (
				<div className="formError" style={{ marginTop: '4px' }}>
					{error}
				</div>
			)}
		</div>
	);
};

export default CountryField;
